import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import slugify from 'slugify'
import TextArea from '../TextArea'
// import Input from 'react-input-mask'
// import layout from './style.css'

// import Erro from '../../images/erro.svg'
// import LupaGray from '../../images/lupaGray.svg'
import ThemeConsumer from '../ThemeConsumer'
import Loading from '../loading/'

class FloatLabelTextArea extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  componentWillMount() {
    if (this.props.value && this.props.value.length) {
      this.handleChange({ target: { value: this.props.value } })
    }
  }

  componentWillReceiveProps(nextProps) {
    const condition = () => {
      // if (this.props.mask.length) {
      //   return nextProps.value !== this.state.value.replace(/[^A-Za-z0-9]/g, '')
      // }
      return nextProps.value !== this.state.value
    }
    if (condition()) {
      this.handleChange({ target: { value: nextProps.value } })
    }
  }

  handleChange = (ev) => {
    // if (this.props.loading) {
    //   return this.setState({
    //     value: this.state.value,
    //   })
    // }
    // return this.setState({
    //   value: ev.target.value,
    // }, () => {
    //   if (this.props.onChange && typeof this.props.onChange === 'function') {
    //     this.props.onChange(this.state.value)
    //   }
    // })

    // const event = ev

    if (this.props.loading) {
      return this.setState({
        value: this.state.value,
      })
    }

    this.setState({
      value: ev.target.value,
    })
  }

  handleKeyPress = (ev) => {
    if (this.props.onKeyPress && typeof this.props.onKeyPress === 'function') {
      this.props.onKeyPress(ev.nativeEvent)
    }
  }

  handleErrorClose = () => {
    this.setState({
      value: '',
    }, () => {
      if (this.props.onChange && typeof this.props.onChange === 'function') {
        this.props.onChange(this.state.value)
      }
    })
  }

  renderIcon() {
    // switch (this.props.icon.toLowerCase()) {
    //   case 'lupagray':
    //     return <LupaGray height={24} width={24} />
    //   default:
    //     return <Erro height={24} width={24} />
    // }
  }

  render() {
    const uid = slugify(this.props.label, { lower: true })
    const { theme, preset, cssClasses, noResize } = this.props


    return (
      <div
        className={`
          ${theme.floatLabel}
          ${this.props.invalid ? theme.invalid : ''}
          ${this.props.icon ? theme.hasIcon : ''}
          ${this.props.loading ? theme.hasLoading : ''}
          ${this.props.disabled ? theme.disabled : ''}
        `}
      >
        <TextArea
          disabled={this.props.disabled}
          key={uid}
          id={this.props.id}
          preset={preset}
          type={this.props.type}
          onChange={this.handleChange}
          onKeyPress={this.handleKeyPress}
          ref={(ref) => { this[uid] = ref }}
          className={`
            ${this.state.value && this.state.value.length ? theme.hasValue : ''}
            ${noResize ? theme.noResize : ''}
            ${cssClasses || ''}
          `}
          value={this.state.value}
          {...this.props}
          // mask={this.props.mask}
          // formatChars={this.props.formatChars}
        />
        {/* eslint-disable jsx-a11y/label-has-for */}
        <label
          htmlFor={this.props.id}
        >
          {/* eslint-enable jsx-a11y/label-has-for */}
          <span>{this.props.label}</span>
          {this.props.required && (
            <span className={ theme.required }> *</span>
          )}
        </label>
        {
          this.props.invalid && (
            <button
              onClick={this.handleErrorClose}
              className={ theme.errorClose }
              type="button"
              tabIndex={-1}
            >
              {/* <Erro
                height={18}
                width={18}
              /> */}
            </button>
          )
        }
        <span className={theme.error}>
          {this.props.invalid && this.props.error}
        </span>
        {
          this.props.icon.length ? (
            <span
              className={`
                ${theme.icon}
                ${this.props.iconClick && typeof this.props.iconClick === 'function' ? theme.pointer : ''}
              `}
              onClick={() => {
                if (this.props.iconClick && typeof this.props.iconClick === 'function') {
                  return this.props.iconClick()
                }
                /* eslint-disable react/no-find-dom-node */
                return ReactDOM.findDOMNode(this[uid]).focus()
                /* eslint-enable react/no-find-dom-node */
              }}
              onKeyPress={() => {}}
              role="button"
              tabIndex={-1}
            >
              {this.renderIcon()}
            </span>
          ) : ''
        }
        {
          this.props.loading ? (
            <span
              className={ theme.loading }
            >
              <Loading model="secondary" size={21} />
            </span>
          ) : ''
        }
      </div>
    )
  }
}

FloatLabelTextArea.propTypes = {
  error: (props, propName) => {
    if (
      props.invalid
      && (!props[propName] || typeof props[propName] !== 'string')
    ) {
      return new Error('Please provide an string error!')
    }
    return null
  },
  invalid: PropTypes.bool,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  type: PropTypes.string,
  icon: PropTypes.string,
  iconClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  // mask: PropTypes.string,
  formatChars: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

}

FloatLabelTextArea.defaultProps = {
  error: '',
  invalid: false,
  required: false,
  onKeyPress: () => {},
  type: 'text',
  icon: '',
  iconClick: null,
  disabled: false,
  loading: false,
  // mask: '',
  formatChars: {
    9: '[0-9]',
    a: '[A-Za-z]',
    '*': '[A-Za-z0-9]',
  },
}

export default ThemeConsumer('UIFloatLabel')(FloatLabelTextArea)



// WEBPACK FOOTER //
// ./src/shared/components/FloatLabelTextArea/index.js